// React
import React, { useState, useRef, useEffect } from "react";
// React
// CSS
import styles from "./AddToHomeScreen.module.css";
import Swal from "sweetalert2";
// CSS

type AddToHomeScreenProps = {
  setCanShowAddToLomeScreen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const AddToHomeScreen: React.FunctionComponent<AddToHomeScreenProps> = ({
  setCanShowAddToLomeScreen,
  setIsModalInScreen,
}) => {
  //
  const [isChecked, setIsChecked] = useState<boolean>(false);
  //

  const innerRef = useRef<HTMLDivElement>(null);
  const outerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!innerRef.current) return;
      if (!outerRef.current) return;

      innerRef.current.style.top = "0";
      outerRef.current.style.opacity = "1";
    }, 50);
  }, []);

  useEffect(() => {
    localStorage.setItem("amoozesh", JSON.stringify(isChecked));
  }, [isChecked]);

  const closeModalWithChecked = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    innerRef.current.style.top = "-100vh";
    outerRef.current.style.opacity = "0";

    setTimeout(() => {
      setIsModalInScreen(false);
      setCanShowAddToLomeScreen(false);
    }, 500);
  };

  const closeModalWithNoChecked = () => {
    if (!innerRef.current) return;
    if (!outerRef.current) return;

    innerRef.current.style.top = "-100vh";
    outerRef.current.style.opacity = "0";

    setTimeout(() => {
      setIsModalInScreen(false);
      setCanShowAddToLomeScreen(true);
    }, 500);
  };

  ////////////////////

  let deferredPrompt: any;
  window.addEventListener("beforeinstallprompt", (e) => {
    deferredPrompt = e;
  });

  /////////////////////
  return (
    <div
      className={`${
        styles.addToHomeScreenContainerModal
      } w-screen h-screen fixed top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } flex items-center justify-center z-30`}
    >
      <div
        className={`${styles.outer} fixed w-screen h-screen top-0 ${
          window.innerWidth > 600 ? "left-auto -ml-8" : "left-0"
        } z-40 `}
        ref={outerRef}
        onClick={() => {
          closeModalWithNoChecked();
        }}
      ></div>
      <div
        className={`${styles.inner}  relative z-50 w-full p-4 bg-white flex flex-col  items-center justify-center mx-2 rounded-xl dark:!text-black`}
        ref={innerRef}
        style={{
          left: window.innerWidth > 600 ? "-18px" : "",
        }}
      >
        <h2 className="text-right text-sm pb-2">
          برای داشتن تجربه ی بهتر ، پیشنهاد میکنیم این برنامه را به صفحه ی اصلی
          گوشی خود از طریق منوی بالای مرورگر خود و انتخاب گرینه ی (add to home
          screen ) اضافه کنید .
        </h2>
        <div
          className="flex items-center justify-center flex-row"
          onClick={() => {
            setIsChecked((prevState) => !prevState);
          }}
        >
          <p className="dark:!text-black text-sm">دیگر این پیام را نمایش نده</p>
          <input
            type="checkbox"
            className="ml-4"
            checked={isChecked}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
          />
        </div>
        <div
          className={`${styles.buttonContainers} flex items-center justify-between w-full`}
        >
          <button
            className={`${styles.submitBtn} text-white w-full py-2 rounded-lg mt-4 text-center text-sm`}
            onClick={() => {
              if (isChecked) {
                closeModalWithChecked();
                return;
              }
              closeModalWithNoChecked();
            }}
          >
            بستن
          </button>
          <button
            id="installApp"
            className={`${styles.submitBtn} ${styles.addToHomeScreen} text-white w-full py-2 rounded-lg mt-4 text-center text-sm`}
            onClick={() => {
              (async () => {
                console.log(deferredPrompt);
                if (deferredPrompt !== null && deferredPrompt !== undefined) {
                  deferredPrompt.prompt();
                  const { outcome } = await deferredPrompt.userChoice;
                  console.log(deferredPrompt.userChoice);
                  if (outcome === "accepted") {
                    deferredPrompt = null;
                    Swal.fire({
                      icon: "success",
                      text: "با موفقیت به صفحه ی اصلی اضافه شد ، لطفا مرورگر خود را ببندید و از صفحه ی اصلی گوشی خود وارد شوید",
                    }).then(() => {
                      closeModalWithNoChecked();
                    });
                  }
                  return;
                }

                Swal.fire({
                  icon: "info",
                  title: "حالت اتوماتیک در دستگاه شما پشتیبانی نمیشود",
                  text: "لطفا خودتان از منوی بالای مرورگر  ، این برنامه را به صفحه ی اصلی اضافه کنید",
                }).then(() => {
                  setTimeout(() => {
                    if (!closeModalWithNoChecked) return;
                    closeModalWithNoChecked();
                  }, 300);
                });
              })();
            }}
          >
            افزودن به صفحه اصلی
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToHomeScreen;
